export function cast<T>(instance: any, ctor: { new(...args: any[]): T }): T {
    if (instance instanceof ctor) {
        return instance;
    }
    throw new Error(`Invalid cast, expected ${ctor}, but got ${instance == null ? typeof instance : instance.constructor}.`);
};